import React, { useEffect, useState } from 'react'
import { getBookCallbackapi } from 'Services/allApi';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BookCallback = () => {
  const [bookcallback, setbookcallback] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    getbookcallbackDetails(currentPage);
  }, [currentPage]);

  const getbookcallbackDetails = async (page) => {
    try {
      setLoading(true);
      const response = await getBookCallbackapi(page);

      if (response?.status === 200 && Array.isArray(response.data.results)) {
        setbookcallback(response.data.results); // Accessing the 'results' inside 'data'
        setTotalPages(Math.ceil(response.data.count / 10)); // Assuming the total count is in the 'data.count'
      } else {
        console.error("Unexpected API Response:", response);
        toast.error('Failed to fetch data');

      }
    } catch (error) {
      console.error("Error fetching contact details:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (direction) => {
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    } else if (direction === "previous" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <>
      <h2 className="mt-5 text-xl font-bold text-center mb-4 dark:text-white">Contact Us Details</h2>

      {loading ? (
        <div className="text-center py-4 text-purple-500">Loading...</div>
      ) : (
        <div>
          <div className="overflow-x-auto">
            <table className="table-auto w-full dark:bg-[#0b14374d] dark:text-white">
              <thead>
                <tr className="bg-gray-100 text-left dark:bg-gray-800 dark:text-white">
                  <th className="px-4 py-2 text-left">Name</th>
                  <th className="px-4 py-2 text-left">Phone</th>
                  <th className="px-4 py-2 text-left">Date</th>
                </tr>
              </thead>
              <tbody>
                {bookcallback.length > 0 ? (
                  bookcallback.map((contact) => (
                    <tr key={contact.id} className="hover:bg-gray-50 dark:hover:bg-gray-800" style={{height:"4rem"}}>
                      <td className="px-4 py-2">{contact.name || "N/A"}</td>
                      <td className="px-4 py-2">{contact.phone || "N/A"}</td>
                      <td className="px-4 py-2">
                        {contact.created_date
                          ? new Date(contact.created_date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "N/A"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-4 py-2 text-center text-red-500"
                    >
                      No Book callback details found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center items-center mt-4 space-x-4">
            <button
              className="rounded-lg bg-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-400"
              disabled={currentPage === 1}
              onClick={() => handlePageChange("previous")}
            >
              Previous
            </button>
            <span className="text-gray-700">Page {currentPage} of {totalPages}</span>
            <button
              className="rounded-lg bg-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-400"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange("next")}
            >
              Next
            </button>
          </div>
        </div>
      )}
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />


    </>)
}

export default BookCallback